var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "judge_question" }, [
    _c("div", { staticClass: "question_title" }, [
      _c("span", [
        _vm._v(
          _vm._s(
            _vm.questionData.sectionName === undefined
              ? ""
              : _vm.questionData.sectionName
          )
        )
      ]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "(" +
            _vm._s(
              _vm.questionData.sectionPrompt +
                " 本题" +
                _vm.questionData.score +
                "分。"
            ) +
            ")"
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "title" }, [
      _vm.questionData.questionContent
        ? _c("div", {
            staticClass: "ql-editor title_one",
            domProps: { innerHTML: _vm._s(_vm.questionData.questionContent) }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("h1", {
        staticClass: "ql-editor",
        staticStyle: { overflow: "auto" },
        domProps: {
          innerHTML: _vm._s(_vm.questionData.questionDto.questionContent)
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "select" },
      [
        _c(
          "el-radio-group",
          {
            attrs: { disabled: _vm.disabledFlag },
            on: { change: _vm.select },
            model: {
              value: _vm.num,
              callback: function($$v) {
                _vm.num = $$v
              },
              expression: "num"
            }
          },
          [
            _c("el-radio", { attrs: { label: 0 } }, [_vm._v("正确")]),
            _vm._v(" "),
            _c("el-radio", { attrs: { label: 1 } }, [_vm._v("错误")])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66013a0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66013a0e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testSumulationComponentNew/judge.vue
// module id = null
// module chunks = 